import { createUseStyles } from 'react-jss';
import { EditableMissionState } from '../../mission/model/EditableMissionState.ts';
import { PlaneIcon } from '../../components/icons/Icons.tsx';
import { dayjs } from '../../support/helpers/dayjs.ts';
import { IAddress } from '../../support/model/IAddress.ts';
import { formatLocalDate } from '../../support/helpers/format.ts';

const useStyles = createUseStyles({
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: '8px 0',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.03)',
            borderRadius: 8
        }
    },
    iconWrapper: {
        marginTop: 2,
        flexShrink: 0
    },
    address: {
        fontSize: 14,
        fontWeight: 500,
        color: 'var(--ion-text-color)',
        lineHeight: '1.3'
    },
    status: {
        fontSize: 12,
        color: 'var(--ion-color-medium)',
        marginTop: 2
    }
});

const formatAddress = (address: IAddress | undefined): string => {
    if (!address) return 'Unknown location';
    const parts = [address.street, address.city].filter(Boolean);
    return parts.join(', ') || 'Unknown location';
};

const formatStatus = (mission: EditableMissionState): string => {
    const isUpcoming = !mission.hasEnded();
    const label = isUpcoming ? 'Upcoming' : 'Completed';
    const date = formatLocalDate({ date: mission.getStartTime(), location: mission.getLocation(), includeYear: true });
    return `${label}, ${date}`;
};

interface IRecentMissionItemProps {
    mission: EditableMissionState;
    onSelect: (mission: EditableMissionState) => void;
}

export const RecentMissionItem: React.FC<IRecentMissionItemProps> = ({ mission, onSelect }) => {
    const classes = useStyles();

    return (
        <div className={classes.row} onClick={() => onSelect(mission)} data-id={`recent-mission-${mission.state.missionId}`}>
            <div className={classes.iconWrapper}>
                <PlaneIcon size="small" color="medium" />
            </div>
            <div>
                <div className={classes.address}>{formatAddress(mission.getAddress())}</div>
                <div className={classes.status}>{formatStatus(mission)}</div>
            </div>
        </div>
    );
};
